import React from 'react';
import type { WorkspaceMember, WorkspaceRole } from '../../../types';
import MemberRow from './MemberRow';

interface Props {
  members: WorkspaceMember[];
  currentUserId: string | undefined;
  currentUserIsAdmin: boolean;
  activeAdminCount: number;
  busyId: string | null;
  onChangeRole: (userId: string, role: WorkspaceRole) => void;
  onRemove: (member: WorkspaceMember) => void;
}

const MembersList: React.FC<Props> = ({
  members,
  currentUserId,
  currentUserIsAdmin,
  activeAdminCount,
  busyId,
  onChangeRole,
  onRemove,
}) => {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold text-white">Members</div>
          <div className="text-xs text-gray-400">
            {members.length} {members.length === 1 ? 'user' : 'users'} in this workspace
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-fixed min-w-[520px]">
          <colgroup>
            <col className="w-[42%]" />
            <col className="w-[24%]" />
            <col className="w-[22%]" />
            <col className="w-[12%]" />
          </colgroup>
          <thead className="bg-white/5 border-b border-white/10">
            <tr className="text-left text-xs uppercase tracking-wider text-gray-400">
              <th className="px-3 py-2 font-medium">Member</th>
              <th className="px-3 py-2 font-medium hidden md:table-cell">Phone</th>
              <th className="px-3 py-2 font-medium">Role</th>
              <th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {members.map((m) => (
              <MemberRow
                key={m.id}
                member={m}
                isSelf={m.id === currentUserId}
                currentUserIsAdmin={currentUserIsAdmin}
                activeAdminCount={activeAdminCount}
                busy={busyId === m.id}
                onChangeRole={onChangeRole}
                onRemove={onRemove}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MembersList;
